module.exports = __webpack_public_path__ + "static/media/Logout.116c038c.svg";